import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/view/home'
Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/ethic',
      name: 'EthicHome',
      component: () => import('@/view/ethicHome')
    },
    {
      path: '/technology',
      name: 'TechnologyHome',
      component: () => import('@/view/technologyHome')
    },
    {
      path: '/notice',
      name: ' Notice',
      component: () => import('@/view/notice')
    },
    {
      path: '/checkMsg',
      name: 'checkMsg',
      component: () => import('@/view/checkMsg')
    }, {
      path: '/policy',
      name: 'policy',
      component: () => import('@/view/policy')
    },
    {
      path: '/policys',
      name: 'policys',
      component: () => import('@/view/policy2')
    },
    {
      path: '/center',
      name: 'Center',
      component: () => import('@/view/center/center')
    }, {
      path: '/enchiridion',
      name: 'enchiridion',
      component: () => import('@/view/enchiridion')
    }, {
      path: '/GCP',
      name: 'GCP',
      component: () => import('@/view/GCP')
    }, {
      path: '/download',
      name: 'download',
      component: () => import('@/view/download')
    }, {
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('@/view/contactUs')
    }, {
      path: '/specialColumn',
      name: 'specialColumn',
      component: () => import('@/view/specialColumn')
    },
    {
      path: '/trainsession',
      name: 'trainsession',
      component: () => import('@/view/trainsession')
    },
    {
      path: '/patentRecommendation',
      name: 'patentRecommendation',
      component: () => import('@/view/patentRecommendation')
    },    {
      path: '/recruit',
      name: 'recruit',
      component: () => import('@/view/recruit/list')
    },
    {
      path: '/recruit/details',
      name: 'details',
      component: () => import('@/view/recruit/details')
    },
    

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js